import {
    Bluesnap,
    BluesnapCardInfoResponse,
    BluesnapError,
    BlueSnapSubmitCallback,
    BluesnapThreeDSecureArgs,
} from "./bluesnap";
import { getCardIconUrl } from "../utils/bluesnapHelper";

declare const bluesnap: Bluesnap;

export default class BluesnapService {
    hostedPaymentFieldsSubmitData = (
        pfToken: string,
        bluesnapThreeDSecureArgs: BluesnapThreeDSecureArgs
    ): Promise<BluesnapCardInfoResponse> => {
        return new Promise((resolve, reject) => {
            bluesnap.hostedPaymentFieldsSubmitData(
                (callback: BlueSnapSubmitCallback) => {
                    console.log("threeDSecure", callback.threeDSecure);

                    if (callback.cardData) {
                        resolve({
                            pfToken,
                            last4Digits: callback.cardData.last4Digits,
                            ccType: callback.cardData.ccType,
                        });
                    } else {
                        const errorArray = callback.error;
                        // tslint:disable-next-line:forin
                        for (const i in errorArray) {
                            // tslint:disable-next-line:no-console
                            console.warn(
                                "Received error: tagId= " +
                                    errorArray[i].tagId +
                                    ", errorCode= " +
                                    errorArray[i].errorCode +
                                    ", errorDescription= " +
                                    errorArray[i].errorDescription
                            );
                        }

                        const errorForUser = BluesnapService.extractBluesnapError(errorArray);
                        reject(errorForUser);
                    }
                },
                {
                    amount: 0,
                    currency: "USD",
                    billingFirstName: bluesnapThreeDSecureArgs.billingFirstName,
                    billingLastName: bluesnapThreeDSecureArgs.billingLastName,
                    phone: bluesnapThreeDSecureArgs.billingPhone,
                    email: bluesnapThreeDSecureArgs.billingEmail,
                }
            );
        });
    };

    private static extractBluesnapError(errors: BluesnapError[]) {
        // try to detect some well know error codes, see: https://developers.bluesnap.com/docs/3-d-secure-for-api#section-error-codes
        if (errors.find((x) => x.errorCode === "14101")) {
            return "3D Secure authentication failed";
        } else if (errors.find((x) => x.errorCode === "14103")) {
            return "3D Secure client error";
        }

        return "Please verify your Credit Card information";
    }

    hostedPaymentFieldsCreate = (
        pfToken: string,
        onType: (url: string) => void,
        onError: (tagId: string, errorDescription: string) => void,
        onValid: (tagId: string) => void,
        onBlur: (tagId: string) => void
    ) => {
        // initialize with generic card image
        onType(getCardIconUrl(null));

        const blueSnapConfiguration = {
            onFieldEventHandler: {
                // don't remove this empty functions as bluesnap starts to complain
                // tslint:disable-next-line:no-empty
                onFocus() {
                    // do nothing
                },
                onBlur(tagId) {
                    onBlur(tagId);
                },
                onError(tagId, errorCode, errorDescription) {
                    onError(tagId, errorDescription);
                },
                onType(tagId, cardType) {
                    const url = getCardIconUrl(cardType);
                    if (url) {
                        onType(url);
                    }
                },
                onEnter() {
                    // do nothing
                },
                onValid(tagId) {
                    onValid(tagId);
                },
            },
            style: {
                ":focus": {
                    color: "#ece9f2",
                },
                input: {
                    color: "#ece9f2",
                    "background-color": "#0f1425",
                    "font-size": "1rem",
                },
                select: {
                    color: "#ece9f2",
                    "font-size": "1rem",
                },
                ".invalid": {
                    color: "#ece9f2",
                },
                ".valid": {
                    color: "#ece9f2",
                },
                "::placeholder": {
                    color: "#aca8bf",
                },
                span: {
                    color: "#aca8bf",
                    "font-size": "22px",
                },
            },
            ccnPlaceHolder: "1234 5678 9012 3456",
            cvvPlaceHolder: "123",
            expPlaceHolder: "MM/YY",
            "3DS": true,
            token: pfToken,
        };
        bluesnap.hostedPaymentFieldsCreate(blueSnapConfiguration);
    };
}
